// @flow

import _ from 'lodash';

import { getCoveredMembers } from 'client/utils/health/applicant';

import type { IfpAppType } from 'web-core/types/ifp-app';

export const getRecommendationParamsFromApp = (app: IfpAppType) => {
  const { address, app_json, members, member_drugs, member_providers } = app;
  const planYear = _.get(app_json, 'plan.planYear');
  const subsidy = _.get(app_json, 'subsidy.amount', null);

  return {
    address,
    memberDrugs: member_drugs,
    members: getCoveredMembers(members),
    planYear,
    providers: _.map(member_providers, p => p.provider_id),
    subsidy,
  };
};
